export default __webpack_public_path__ + "assets/botswana-flag.png";